var INVALID_HEX_CHAR_ERROR = 1;
var NOT_VALID_HEX_CHARACTER = -1;
var NO_HEX_CONVERSION_ERRORS = 0;
var ERR_NO_ERROR = 0;
var HEX_RADIX = 16;
var NUM_OF_NIBBLES_PER_BYTE = 2;
var HEX_CASE = 0;
var C_String = "";
var P_String = "";
var key;
var PINBlockType = "";
var PINBlockLength = 0;
var PINBlockByteArray = [];
// need to declare the max and min lengh of password
var MAX_PIN_STRING_SIZE = 16;
var MIN_PIN_STRING_SIZE = 7;
//  generated public key by following fields
var publicExponentString = '00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000010001';
var { modulusString } = process.env;

var PIN_BLOCK_FILL_CHARACTER = 0xff;
var FMT_2_CONTROL_BYTE = 0x02;
var FMT_12_CONTROL_BYTE = 0xc1;
var ISO_FORMAT_2_TYPE = 1;
var ISO_FORMAT_12_TYPE = 2;

var MAX_NUMERIC_PIN_STRING_SIZE = 12;
var MAX_NUMERIC_PIN_BYTE_SIZE = 6;
var DECIMAL_RADIX = 10;
var NUM_OF_BYTES_IN_FMT2_PIN_BLOCK = 8;
var NUM_OF_BYTES_PER_CNTRL_AND_PIN_LENGTH = 2;
var ENCODING_PARAMETER_SIZE_IN_BYTES = 16;
var RANDOM_SEED_SIZE_IN_BYTES = 20;

var RSA_MODULUS_SIZE_IN_BITS = 2048;
var RSA_MODULUS_SIZE_IN_BYTES = parseInt(RSA_MODULUS_SIZE_IN_BITS / 8);
var RSA_EXPONENT_SIZE_IN_BYTES = parseInt(RSA_MODULUS_SIZE_IN_BITS / 8);
var ONE_PIN_BLOCK_IN_MESSAGE = 1;
var SHA1_HASH_SIZE_IN_BYTES = 20;
var OAEP_SHA1_OFFSET_IN_BYTES = 42;
var MIN_PIN_MESSAGE_SIZE_IN_BYTES = 17;
var MIN_PIN_BLOCK_SIZE = 8;
var MAX_MESSAGE_SIZE_IN_BYTES = RSA_MODULUS_SIZE_IN_BYTES - OAEP_SHA1_OFFSET_IN_BYTES;
var MIN_RANDOM_NUMBER_STRING_LENGTH = MIN_PIN_BLOCK_SIZE * NUM_OF_NIBBLES_PER_BYTE;
var ENCODED_MESSAGE_SIZE_IN_BYTES = RSA_MODULUS_SIZE_IN_BYTES - 1;
var DATA_BLOCK_SIZE_IN_BYTES = ENCODED_MESSAGE_SIZE_IN_BYTES - SHA1_HASH_SIZE_IN_BYTES;
var MAX_PIN_MESSAGE_SIZE_IN_BYTES = RSA_MODULUS_SIZE_IN_BYTES - OAEP_SHA1_OFFSET_IN_BYTES;

var ERR_INVALID_PIN_LENGTH = 10;
var ERR_INVALID_PIN = 11;
var ERR_INVALID_PIN_BLOCK = 20;
var ERR_INVALID_RANDOM_NUMBER_LENGTH = 21;
var ERR_INVALID_RANDOM_NUMBER = 22;
var ERR_INVALID_PIN_MESSAGE = 30;
var ERR_INVALID_PIN_MESSAGE_LENGTH = 31;
var ERR_INVALID_ENCODED_MSG_LENGTH = 40;
var ERR_INVALID_RSA_KEY_LENGTH = 41;
var ERR_INVALID_RSA_KEY = 42;

var modulus;
var publicExponent;
var chunkSize;
var PINLength;

var P = new Array(ENCODING_PARAMETER_SIZE_IN_BYTES);
var maxOutputDataSizeInBytes;

function getEncryptedUserLoginMsg() {
  return C_String;
}

function getEncodingParameter() {
  return P_String;
}

function fillByteArray(aa, ba) {
  var ca;
  var da = aa.length;
  for (ca = 0; ca < da; ca++) {
    aa[ca] = ba;
  }
  return aa;
}

function convertHexArrayToString(ea) {
  var fa;
  var ga = "";
  var ha = ea.length;
  var ia;
  var ja;
  for (fa = 0; fa < ha; fa++) {
    ia = ea[fa] & (0xf0 >> 4);
    ja = parseInt(ia, HEX_RADIX);
    ga = ga + ja.toUpperCase();
    ia = ea[fa] & 0x0f;
    ja = parseInt(ia, HEX_RADIX);
    ga = ga + ja.toUpperCase();
  }
  return ga;
}

function convertToHexString(ka) {
  var la = HEX_CASE ? "0123456789ABCDEF" : "0123456789abcdef";
  var ma = "";
  for (var i = 0; i < ka.length; i++) {
    ma += la.charAt((ka[i] >> 4) & 0xf) + la.charAt(ka[i] & 0xf);
  }
  return ma;
}

function convertAsciiArrayToHexByteArray(na, oa, pa, qa) {
  var ra;
  var sa;
  var ta;
  var ua;
  ua = parseInt((qa + 1) / 2);
  for (sa = 0, ta = 0; sa < ua; sa++) {
    if (ta < qa - 1) {
      ra = parseInt(na[ta] & 0x0f) << 4;
      ra = ra | parseInt(na[ta + 1] & 0x0f);
    } else {
      ra = parseInt(oa[sa + pa] & 0x0f);
      ra = ra | (parseInt(na[ta] & 0x0f) << 4);
    }
    oa[sa + pa] = ra;
    ta += NUM_OF_NIBBLES_PER_BYTE;
  }
  return oa;
}

function convertStringToPackedHexByteArray(va, wa, xa) {
  var ya = va.length;
  var za, byteCount, hexValue, temp;
  var Aa;
  for (za = 0, byteCount = 0; za < ya; za++, byteCount++) {
    Aa = va.charAt(za);
    hexValue = parseInt(Aa, HEX_RADIX);
    if (hexValue == NOT_VALID_HEX_CHARACTER) {
      return INVALID_HEX_CHAR_ERROR;
    }
    temp = hexValue << 4;
    za++;
    if (za < ya) {
      Aa = va.charAt(za);
      hexValue = parseInt(Aa, HEX_RADIX);
      if (hexValue == NOT_VALID_HEX_CHARACTER) {
        return INVALID_HEX_CHAR_ERROR;
      }
      wa[byteCount + xa] = temp | hexValue;
    } else {
      wa[byteCount + xa] = temp | 0x0f;
    }
  }
  return NO_HEX_CONVERSION_ERRORS;
}

function PINBlock(PINBlockByteArray) {
  this.length = PINBlockByteArray.length;
  this.byteArray = PINBlockByteArray;
}

function createPINBlock(pinString, RN_String) {
  var index;
  var PinStringByteArray = new Array(MAX_PIN_STRING_SIZE);
  var numericPinStringByteArray = new Array(MAX_NUMERIC_PIN_STRING_SIZE);
  var pinChar;
  var pinCharCd;
  var isInvalidCharFound = false;
  var isPINNumeric = false;

  if (pinString === "") {
    return ERR_INVALID_PIN;
  }

  PINLength = pinString.length;
  if (PINLength > MAX_PIN_STRING_SIZE || PINLength < MIN_PIN_STRING_SIZE) {
    return ERR_INVALID_PIN_LENGTH;
  }

  if (PINLength <= MAX_NUMERIC_PIN_STRING_SIZE) {
    isPINNumeric = true;
  }

  for (index = 0; index < PINLength; index++) {
    pinChar = pinString.charAt(index);
    pinCharCd = pinString.charCodeAt(index);
    if (isPINNumeric) {
      if (isNaN(pinChar)) {
        isPINNumeric = false;
      } else {
        numericPinStringByteArray[index] = parseInt(pinChar, DECIMAL_RADIX);
      }
    }
    PinStringByteArray[index] = pinCharCd;
  }

  if (isPINNumeric) {
    createFormat2PINBlock(numericPinStringByteArray, PINLength, RN_String);
  } else {
    createFormat12PINBlock(PinStringByteArray, PINLength, RN_String);
  }

  return 0;
}

function createFormat2PINBlock(numericPinByteArray, PINLength, RN_String) {
  var tempInt;

  PINBlockType = ISO_FORMAT_2_TYPE;
  PINBlockLength = NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  tempInt = FMT_2_CONTROL_BYTE << 4;
  PINBlockByteArray[0] = tempInt | (PINLength & 0x00ff);
  PINBlockByteArray = convertAsciiArrayToHexByteArray(
    numericPinByteArray,
    PINBlockByteArray,
    1,
    PINLength
  );
  createPINMessage(PINBlockByteArray, RN_String);
  return;
}

function createFormat12PINBlock(PinStringByteArray, PINLength, RN_String) {
  var numberOfPINBlocks;

  PINBlockType = ISO_FORMAT_12_TYPE;
  if (PINLength <= 6) {
    numberOfPINBlocks = 1;
  } else {
    numberOfPINBlocks =
      2 + parseInt((PINLength - 7) / NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  PINBlockLength = numberOfPINBlocks * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;

  switch (numberOfPINBlocks) {
    case 1:
      PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 2:
      PINBlockByteArray = new Array(2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 3:
      PINBlockByteArray = new Array(3 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    default:
      PINBlockByteArray = new Array(4 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );

  PINBlockByteArray[0] = FMT_12_CONTROL_BYTE;
  PINBlockByteArray[1] = PINLength;
  arrayCopy(PinStringByteArray, 0, PINBlockByteArray, 2, PINLength);
  createPINMessage(PINBlockByteArray, RN_String);
  return;
}

function createPINMessage(pinBlockByteArray, RN_String) {
  var pinMessageArray;
  var pinMessageLength;
  var pinBlockLength;
  var pinMessageVector;
  var RNStringLength;
  var RNByteLength;
  var maxRandomNumberStringSize;
  var conversionError;

  pinMessageArray = new Array(MAX_MESSAGE_SIZE_IN_BYTES);
  pinMessageArray[0] = ONE_PIN_BLOCK_IN_MESSAGE;
  pinMessageLength = 1;

  if (pinBlockByteArray == null) {
    return ERR_INVALID_PIN_BLOCK;
  }

  pinBlockLength = pinBlockByteArray.length;
  arrayCopy(
    pinBlockByteArray,
    0,
    pinMessageArray,
    pinMessageLength,
    pinBlockLength
  );
  pinMessageLength = pinMessageLength + pinBlockLength;

  if (RN_String == null) {
    return ERR_INVALID_RANDOM_NUMBER;
  }
  RNStringLength = RN_String.length;
  RNByteLength = parseInt((RNStringLength + 1) / 2);

  maxRandomNumberStringSize =
    (MAX_MESSAGE_SIZE_IN_BYTES - pinMessageLength) * NUM_OF_NIBBLES_PER_BYTE;

  if (
    RNStringLength < MIN_RANDOM_NUMBER_STRING_LENGTH ||
    RNStringLength > maxRandomNumberStringSize ||
    RNStringLength != RNByteLength * 2
  ) {
    return ERR_INVALID_RANDOM_NUMBER_LENGTH;
  }

  conversionError = convertStringToPackedHexByteArray(
    RN_String,
    pinMessageArray,
    pinMessageLength
  );

  if (conversionError != NO_HEX_CONVERSION_ERRORS) {
    return ERR_INVALID_RANDOM_NUMBER;
  }
  pinMessageLength = pinMessageLength + RNByteLength;

  pinMessageVector = new Array(pinMessageLength);
  for (var index = 0; index < pinMessageLength; index++) {
    pinMessageVector[index] = pinMessageArray[index];
  }
  OAEPEncodedPINMessage(pinMessageVector);
  return;
}

function OAEPEncodedPINMessage(pinMessageArray) {
  var encodedMsgByteArray = new Array(ENCODED_MESSAGE_SIZE_IN_BYTES);
  var encodedMessageString;
  var encodingParameterString;
  var encMsgArray;

  encodedMsgByteArray = doOAEPEncoding(pinMessageArray);
  encodedMessageString = convertToHexString(encodedMsgByteArray);
  encodingParameterString = convertToHexString(P);

  var strPartLengthP = parseInt(encodedMessageString.length / 8);
  P_String = encodingParameterString.toUpperCase();

  encMsgArray = encryptMessageRSA(encodedMessageString);

  var diff_len = RSA_MODULUS_SIZE_IN_BYTES * 2 - encMsgArray.length;
  if (diff_len > 0) {
    for (var index = 0; index < diff_len; index++) {
      encMsgArray = "0" + encMsgArray;
    }
  }

  C_String = encMsgArray.toUpperCase();

  return;
}

function doOAEPEncoding(pinMessageArray) {
  var encodedMsgByteArray = new Array(ENCODED_MESSAGE_SIZE_IN_BYTES);
  var pinMsgLength;
  var offset;
  var numberOfPaddingBytes;

  var pinMsgbyteArray = new Array(MAX_PIN_MESSAGE_SIZE_IN_BYTES);
  var pHash = new Array(SHA1_HASH_SIZE_IN_BYTES);
  var DB = new Array(DATA_BLOCK_SIZE_IN_BYTES);
  var dbMask = new Array(DATA_BLOCK_SIZE_IN_BYTES);
  var maskedDB = new Array(DATA_BLOCK_SIZE_IN_BYTES);
  var seed = new Array(SHA1_HASH_SIZE_IN_BYTES);
  var seedMask = new Array(SHA1_HASH_SIZE_IN_BYTES);
  var maskedSeed = new Array(SHA1_HASH_SIZE_IN_BYTES);

  if (pinMessageArray == null) {
    return ERR_INVALID_PIN_MESSAGE;
  }
  pinMsgLength = pinMessageArray.length;

  if (
    pinMsgLength < MIN_PIN_MESSAGE_SIZE_IN_BYTES ||
    pinMsgLength > MAX_PIN_MESSAGE_SIZE_IN_BYTES
  ) {
    return ERR_INVALID_PIN_MESSAGE_LENGTH;
  }

  P = randomGenerator(ENCODING_PARAMETER_SIZE_IN_BYTES);
  pHash = doHash(P, ENCODING_PARAMETER_SIZE_IN_BYTES);

  fillByteArray(DB, 0x00);
  arrayCopy(pHash, 0, DB, 0, SHA1_HASH_SIZE_IN_BYTES);
  offset = SHA1_HASH_SIZE_IN_BYTES;
  numberOfPaddingBytes =
    DATA_BLOCK_SIZE_IN_BYTES - SHA1_HASH_SIZE_IN_BYTES - pinMsgLength - 1;
  offset += numberOfPaddingBytes;
  DB[offset] = parseInt(0x01);
  offset++;

  copyByteArray(pinMessageArray, pinMsgbyteArray, pinMsgLength);
  arrayCopy(pinMsgbyteArray, 0, DB, offset, pinMsgLength);

  seed = randomGenerator(RANDOM_SEED_SIZE_IN_BYTES);

  MGF1(seed, dbMask, DATA_BLOCK_SIZE_IN_BYTES);

  xorByteArrays(DB, dbMask, maskedDB);

  MGF1(maskedDB, seedMask, SHA1_HASH_SIZE_IN_BYTES);

  xorByteArrays(seed, seedMask, maskedSeed);

  arrayCopy(maskedSeed, 0, encodedMsgByteArray, 0, SHA1_HASH_SIZE_IN_BYTES);
  arrayCopy(
    maskedDB,
    0,
    encodedMsgByteArray,
    SHA1_HASH_SIZE_IN_BYTES,
    DATA_BLOCK_SIZE_IN_BYTES
  );

  return encodedMsgByteArray;
}

function MGF1(Z, T, l) {
  var C = new Array(NUM_OF_BYTES_PER_WORD);
  var tempArray = new Array(ENCODED_MESSAGE_SIZE_IN_BYTES);
  var hashArray = new Array(SHA1_HASH_SIZE_IN_BYTES);

  var maxCount, seedLength, offset, remainingBytes, numberOfBytesToCopy;

  seedLength = Z.length;
  maxCount = parseInt(l / SHA1_HASH_SIZE_IN_BYTES);
  remainingBytes = l - maxCount * SHA1_HASH_SIZE_IN_BYTES;

  if (remainingBytes > 0) {
    maxCount++;
  }

  numberOfBytesToCopy = SHA1_HASH_SIZE_IN_BYTES;

  for (var counter = 0; counter < maxCount; counter++) {
    convertIntToByteArray(counter, C, 0);
    arrayCopy(Z, 0, tempArray, 0, seedLength);
    arrayCopy(C, 0, tempArray, seedLength, NUM_OF_BYTES_PER_WORD);

    hashArray = doHash(tempArray, seedLength + NUM_OF_BYTES_PER_WORD);

    offset = counter * SHA1_HASH_SIZE_IN_BYTES;

    if (counter == maxCount - 1 && remainingBytes > 0) {
      numberOfBytesToCopy = remainingBytes;
    }

    arrayCopy(hashArray, 0, T, offset, numberOfBytesToCopy);
  }
  return;
}

function xorByteArrays(byteArray1, byteArray2, resultByteArray) {
  var index, byteArrayLength;

  byteArrayLength = byteArray1.length;
  for (index = 0; index < byteArrayLength; index++) {
    resultByteArray[index] = parseInt(byteArray1[index] ^ byteArray2[index]);
  }
  return;
}

function randomGenerator(length) {
  var randomHexArray = new Array(length);
  var randomNo1;
  var randomNo2;
  for (var i = 0; i < randomHexArray.length; i++) {
    randomNo1 = Math.floor(Math.random() * 16);
    randomNo2 = Math.floor(Math.random() * 16);
    randomHexArray[i] = (randomNo1 << 4) + randomNo2;
  }
  return randomHexArray;
}

function fixPGenerator(fixP) {
  var tmpP = new Array(ENCODING_PARAMETER_SIZE_IN_BYTES);
  for (var i = 0; i < fixP.length; i += 2) {
    tmpP[parseInt(i / 2)] =
      (parseInt(fixP.charAt(i), HEX_RADIX) << 4) +
      parseInt(fixP.charAt(i + 1), HEX_RADIX);
  }
  return tmpP;
}

function fixSeedGenerator(fixSeed) {
  var seed = new Array(ENCODING_PARAMETER_SIZE_IN_BYTES);
  for (var i = 0; i < fixSeed.length; i += 2) {
    seed[parseInt(i / 2)] =
      (parseInt(fixSeed.charAt(i), HEX_RADIX) << 4) +
      parseInt(fixSeed.charAt(i + 1), HEX_RADIX);
  }
  return seed;
}

function copyByteArray(srcByteArray, destByteArray, NumOfBytesToCopy) {
  for (var index = 0; index < NumOfBytesToCopy; index++) {
    destByteArray[index] = srcByteArray[index];
  }
  return;
}

function encryptMessageRSA(oaepEncMessage) {
  var encMsgByteArray;

  if (modulusString == null || publicExponentString == null) {
    return ERR_INVALID_RSA_KEY_LENGTH;
  }

  if (oaepEncMessage == null) {
    return ERR_INVALID_ENCODED_MSG_LENGTH;
  }

  var rsa = new RSAKey();

  rsa.setPublic(modulusString, publicExponentString);

  validateRSAEncInputData(oaepEncMessage.length);

  encMsgByteArray = rsa.encrypt(oaepEncMessage);

  return encMsgByteArray;
}

function validateRSAEncInputData(inputDataLength) {
  var modulusSizeInBits;
  var maxInputDataSizeInBytes;
  var modulusSizeInBytes = parseInt((modulusString.length + 1) / 2);
  var publicExponentSizeInBytes = parseInt(
    (publicExponentString.length + 1) / 2
  );

  if (
    modulusSizeInBytes != RSA_MODULUS_SIZE_IN_BYTES ||
    publicExponentSizeInBytes != RSA_MODULUS_SIZE_IN_BYTES
  ) {
    return ERR_INVALID_RSA_KEY_LENGTH;
  }

  modulusSizeInBits = modulusSizeInBytes * 8;
  maxOutputDataSizeInBytes = parseInt((modulusSizeInBits + 7) / 8);
  maxInputDataSizeInBytes = maxOutputDataSizeInBytes - 1;

  if (inputDataLength > maxInputDataSizeInBytes + 1) {
    return ERR_INVALID_ENCODED_MSG_LENGTH;
  }

  return;
}
var TWO_PIN_BLOCKS_IN_MESSAGE = 2;

function CP_createPINBlock(aa, ba, ca) {
  var da;
  var ea = new Array(MAX_PIN_STRING_SIZE);
  var fa = new Array(MAX_NUMERIC_PIN_STRING_SIZE);
  var ga;
  var ha;
  var ia = false;
  var ja = false;
  if (aa == "") {
    return ERR_INVALID_PIN;
  }
  PINLength = aa.length;
  if (PINLength > MAX_PIN_STRING_SIZE || PINLength < MIN_PIN_STRING_SIZE) {
    return ERR_INVALID_PIN_LENGTH;
  }
  if (PINLength <= MAX_NUMERIC_PIN_STRING_SIZE) {
    ja = true;
  }
  for (da = 0; da < PINLength; da++) {
    ga = aa.charAt(da);
    ha = aa.charCodeAt(da);
    if (ja) {
      if (isNaN(ga)) {
        ja = false;
      } else {
        fa[da] = parseInt(ga, DECIMAL_RADIX);
      }
    }
    ea[da] = ha;
  }
  var ka = new Array(MAX_PIN_STRING_SIZE);
  var la = new Array(MAX_NUMERIC_PIN_STRING_SIZE);
  var ma;
  var na;
  if (ba == "") {
    return ERR_INVALID_PIN;
  }
  PINLength = ba.length;
  if (PINLength > MAX_PIN_STRING_SIZE || PINLength < MIN_PIN_STRING_SIZE) {
    return ERR_INVALID_PIN_LENGTH;
  }
  if (PINLength <= MAX_NUMERIC_PIN_STRING_SIZE) {
    ja = true;
  }
  for (da = 0; da < PINLength; da++) {
    ma = ba.charAt(da);
    na = ba.charCodeAt(da);
    if (ja) {
      if (isNaN(ma)) {
        ja = false;
      } else {
        la[da] = parseInt(ma, DECIMAL_RADIX);
      }
    }
    ka[da] = na;
  }
  if (ja) {
    CP_createFormat2PINBlockSL(fa, la, aa.length, ba.length, ca);
  } else {
    CP_createFormat12PINBlockSL(ea, ka, aa.length, ba.length, ca);
  }
  return 0;
}

function CP_createFormat2PINBlock(oa, pa, qa, ra) {
  var sa;
  PINBlockType = ISO_FORMAT_2_TYPE;
  PINBlockLength = NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  sa = FMT_2_CONTROL_BYTE << 4;
  PINBlockByteArray[0] = sa | (qa & 0x00ff);
  PINBlockByteArray = convertAsciiArrayToHexByteArray(
    oa,
    PINBlockByteArray,
    1,
    qa
  );
  NEW_PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  NEW_PINBlockByteArray = fillByteArray(
    NEW_PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  sa = FMT_2_CONTROL_BYTE << 4;
  NEW_PINBlockByteArray[0] = sa | (qa & 0x00ff);
  NEW_PINBlockByteArray = convertAsciiArrayToHexByteArray(
    pa,
    NEW_PINBlockByteArray,
    1,
    qa
  );
  CP_createPINMessage(PINBlockByteArray, NEW_PINBlockByteArray, ra);
  return;
}

function CP_createFormat12PINBlock(ta, ua, va, wa) {
  var xa;
  PINBlockType = ISO_FORMAT_12_TYPE;
  if (va <= 6) {
    xa = 1;
  } else {
    xa = 2 + parseInt((va - 7) / NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  PINBlockLength = xa * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  switch (xa) {
    case 1:
      PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      NEW_PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 2:
      PINBlockByteArray = new Array(2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      NEW_PINBlockByteArray = new Array(2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 3:
      PINBlockByteArray = new Array(3 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      NEW_PINBlockByteArray = new Array(3 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    default:
      PINBlockByteArray = new Array(4 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      NEW_PINBlockByteArray = new Array(4 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  PINBlockByteArray[0] = FMT_12_CONTROL_BYTE;
  PINBlockByteArray[1] = va;
  arrayCopy(ta, 0, PINBlockByteArray, 2, va);
  NEW_PINBlockByteArray = fillByteArray(
    NEW_PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  NEW_PINBlockByteArray[0] = FMT_12_CONTROL_BYTE;
  NEW_PINBlockByteArray[1] = va;
  arrayCopy(ua, 0, NEW_PINBlockByteArray, 2, va);
  CP_createPINMessage(PINBlockByteArray, NEW_PINBlockByteArray, wa);
  return;
}

function CP_createFormat2PINBlockSL(oa, pa, qa1, qa2, ra) {
  var sa;
  PINBlockType = ISO_FORMAT_2_TYPE;
  PINBlockLength = NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  sa = FMT_2_CONTROL_BYTE << 4;
  PINBlockByteArray[0] = sa | (qa1 & 0x00ff);
  PINBlockByteArray = convertAsciiArrayToHexByteArray(
    oa,
    PINBlockByteArray,
    1,
    qa1
  );

  NEW_PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  NEW_PINBlockByteArray = fillByteArray(
    NEW_PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  sa = FMT_2_CONTROL_BYTE << 4;
  NEW_PINBlockByteArray[0] = sa | (qa2 & 0x00ff);
  NEW_PINBlockByteArray = convertAsciiArrayToHexByteArray(
    pa,
    NEW_PINBlockByteArray,
    1,
    qa2
  );
  CP_createPINMessage(PINBlockByteArray, NEW_PINBlockByteArray, ra);
  return;
}

function CP_createFormat12PINBlockSL(ta, ua, va1, va2, wa) {
  var xa1, xa2;
  PINBlockType = ISO_FORMAT_12_TYPE;
  if (va1 <= 6) {
    xa1 = 1;
  } else {
    xa1 = 2 + parseInt((va1 - 7) / NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  if (va2 <= 6) {
    xa2 = 1;
  } else {
    xa2 = 2 + parseInt((va2 - 7) / NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  PINBlockLength1 = xa1 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  PINBlockLength2 = xa2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK;
  switch (xa1) {
    case 1:
      PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 2:
      PINBlockByteArray = new Array(2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 3:
      PINBlockByteArray = new Array(3 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    default:
      PINBlockByteArray = new Array(4 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }
  switch (xa2) {
    case 1:
      NEW_PINBlockByteArray = new Array(NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 2:
      NEW_PINBlockByteArray = new Array(2 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    case 3:
      NEW_PINBlockByteArray = new Array(3 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
      break;
    default:
      NEW_PINBlockByteArray = new Array(4 * NUM_OF_BYTES_IN_FMT2_PIN_BLOCK);
  }

  PINBlockByteArray = fillByteArray(
    PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  PINBlockByteArray[0] = FMT_12_CONTROL_BYTE;
  PINBlockByteArray[1] = va1;
  arrayCopy(ta, 0, PINBlockByteArray, 2, va1);
  NEW_PINBlockByteArray = fillByteArray(
    NEW_PINBlockByteArray,
    PIN_BLOCK_FILL_CHARACTER
  );
  NEW_PINBlockByteArray[0] = FMT_12_CONTROL_BYTE;
  NEW_PINBlockByteArray[1] = va2;
  arrayCopy(ua, 0, NEW_PINBlockByteArray, 2, va2);
  CP_createPINMessage(PINBlockByteArray, NEW_PINBlockByteArray, wa);
  return;
}

function CP_createPINMessage(ya, za, Aa) {
  var Ba;
  var Ca;
  var Da;
  var Ea;
  var Fa;
  var Ga;
  var Ha;
  var Ia;
  Ba = new Array(MAX_MESSAGE_SIZE_IN_BYTES);
  Ba[0] = TWO_PIN_BLOCKS_IN_MESSAGE;
  Ca = 1;
  if (ya == null) {
    return ERR_INVALID_PIN_BLOCK;
  }
  if (za == null) {
    return ERR_INVALID_PIN_BLOCK;
  }
  Da = ya.length;
  arrayCopy(ya, 0, Ba, Ca, Da);
  Ca = Ca + Da;
  Da = za.length;
  arrayCopy(za, 0, Ba, Ca, Da);
  Ca = Ca + Da;
  if (Aa == null) {
    return ERR_INVALID_RANDOM_NUMBER;
  }
  Fa = Aa.length;
  Ga = parseInt((Fa + 1) / 2);
  Ha = (MAX_MESSAGE_SIZE_IN_BYTES - Ca) * NUM_OF_NIBBLES_PER_BYTE;
  if (Fa < MIN_RANDOM_NUMBER_STRING_LENGTH || Fa > Ha || Fa != Ga * 2) {
    return ERR_INVALID_RANDOM_NUMBER_LENGTH;
  }
  Ia = convertStringToPackedHexByteArray(Aa, Ba, Ca);
  if (Ia != NO_HEX_CONVERSION_ERRORS) {
    return ERR_INVALID_RANDOM_NUMBER;
  }
  Ca = Ca + Ga;
  Ea = new Array(Ca);
  for (var Ja = 0; Ja < Ca; Ja++) {
    Ea[Ja] = Ba[Ja];
  }
  OAEPEncodedPINMessage(Ea);
  return;
}
var biRadixBase = 2;
var biRadixBits = 16;
var bitsPerDigit = biRadixBits;
var biRadix = 1 << 16;
var biHalfRadix = biRadix >>> 1;
var biRadixSquared = biRadix * biRadix;
var maxDigitVal = biRadix - 1;
var maxInteger = 9999999999999998;
var maxDigits;
var ZERO_ARRAY;
var bigZero, bigOne;

function setMaxDigits(aa) {
  maxDigits = aa;
  ZERO_ARRAY = new Array(maxDigits);
  for (var ba = 0; ba < ZERO_ARRAY.length; ba++) ZERO_ARRAY[ba] = 0;
  bigZero = new BigInt();
  bigOne = new BigInt();
  bigOne.digits[0] = 1;
}
setMaxDigits(20);
var dpl10 = 15;
var lr10 = biFromNumber(1000000000000000);
function BigInt(ca) {
  if (typeof ca == "boolean" && ca == true) {
    this.digits = null;
  } else {
    this.digits = ZERO_ARRAY.slice(0);
  }
  this.isNeg = false;
}

function biFromDecimal(s) {
  var da = s.charAt(0) == "-";
  var i = da ? 1 : 0;
  var ea;
  while (i < s.length && s.charAt(i) == "0") ++i;
  if (i == s.length) {
    ea = new BigInt();
  } else {
    var fa = s.length - i;
    var ga = fa % dpl10;
    if (ga == 0) ga = dpl10;
    ea = biFromNumber(Number(s.substr(i, ga)));
    i += ga;
    while (i < s.length) {
      ea = biAdd(
        biMultiply(ea, lr10),
        biFromNumber(Number(s.substr(i, dpl10)))
      );
      i += dpl10;
    }
    ea.isNeg = da;
  }
  return ea;
}

function biCopy(bi) {
  var ha = new BigInt(true);
  ha.digits = bi.digits.slice(0);
  ha.isNeg = bi.isNeg;
  return ha;
}

function biFromNumber(i) {
  var ia = new BigInt();
  ia.isNeg = i < 0;
  i = Math.abs(i);
  var j = 0;
  while (i > 0) {
    ia.digits[j++] = i & maxDigitVal;
    i >>= biRadixBits;
  }
  return ia;
}

function reverseStr(s) {
  var ja = "";
  for (var i = s.length - 1; i > -1; --i) {
    ja += s.charAt(i);
  }
  return ja;
}

var hexatrigesimalToChar = new Array(
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
);

function biToString(x, ka) {
  var b = new BigInt();
  b.digits[0] = ka;
  var qr = biDivideModulo(x, b);
  var la = hexatrigesimalToChar[qr[1].digits[0]];
  while (biCompare(qr[0], bigZero) == 1) {
    qr = biDivideModulo(qr[0], b);
    digit = qr[1].digits[0];
    la += hexatrigesimalToChar[qr[1].digits[0]];
  }
  return (x.isNeg ? "-" : "") + reverseStr(la);
}

function biToDecimal(x) {
  var b = new BigInt();
  b.digits[0] = 10;
  var qr = biDivideModulo(x, b);
  var ma = String(qr[1].digits[0]);
  while (biCompare(qr[0], bigZero) == 1) {
    qr = biDivideModulo(qr[0], b);
    ma += String(qr[1].digits[0]);
  }

  return (x.isNeg ? "-" : "") + reverseStr(ma);
}

var hexToChar = new Array(
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f"
);

function digitToHex(n) {
  var na = 0xf;
  var oa = "";
  for (i = 0; i < 4; ++i) {
    oa += hexToChar[n & na];
    n >>>= 4;
  }
  return reverseStr(oa);
}

function biToHex(x) {
  var pa = "";
  var n = biHighIndex(x);
  for (var i = biHighIndex(x); i > -1; --i) {
    pa += digitToHex(x.digits[i]);
  }
  return pa;
}

function charToHex(c) {
  var qa = 48;
  var ra = qa + 9;
  var sa = 97;
  var ta = sa + 25;
  var ua = 65;
  var va = 65 + 25;
  var wa;
  if (c >= qa && c <= ra) {
    wa = c - qa;
  } else if (c >= ua && c <= va) {
    wa = 10 + c - ua;
  } else if (c >= sa && c <= ta) {
    wa = 10 + c - sa;
  } else {
    wa = 0;
  }
  return wa;
}

function hexToDigit(s) {
  var xa = 0;
  var sl = Math.min(s.length, 4);
  for (var i = 0; i < sl; ++i) {
    xa <<= 4;
    xa |= charToHex(s.charCodeAt(i));
  }
  return xa;
}

function biFromHex(s) {
  var ya = new BigInt();
  var sl = s.length;
  for (var i = sl, j = 0; i > 0; i -= 4, ++j) {
    ya.digits[j] = hexToDigit(s.substr(Math.max(i - 4, 0), Math.min(i, 4)));
  }
  return ya;
}

function biFromString(s, za) {
  var Aa = s.charAt(0) == "-";
  var Ba = Aa ? 1 : 0;
  var Ca = new BigInt();
  var Da = new BigInt();
  Da.digits[0] = 1;
  for (var i = s.length - 1; i >= Ba; i--) {
    var c = s.charCodeAt(i);
    var Ea = charToHex(c);
    var Fa = biMultiplyDigit(Da, Ea);
    Ca = biAdd(Ca, Fa);
    Da = biMultiplyDigit(Da, za);
  }
  Ca.isNeg = Aa;
  return Ca;
}

function biFromChar(c, Ga) {
  var Ha = new BigInt();
  var Ia = new BigInt();
  Ia.digits[0] = 1;
  var Ja = charToHex(c);
  var Ka = biMultiplyDigit(Ia, Ja);
  return Ha;
}

function biDump(b) {
  return (b.isNeg ? "-" : "") + b.digits.join(" ");
}

function biAdd(x, y) {
  var La;
  if (x.isNeg != y.isNeg) {
    y.isNeg = !y.isNeg;
    La = biSubtract(x, y);
    y.isNeg = !y.isNeg;
  } else {
    La = new BigInt();
    var c = 0;
    var n;
    for (var i = 0; i < x.digits.length; ++i) {
      n = x.digits[i] + y.digits[i] + c;
      La.digits[i] = n & 0xffff;
      c = Number(n >= biRadix);
    }
    La.isNeg = x.isNeg;
  }
  return La;
}

function biSubtract(x, y) {
  var Ma;
  if (x.isNeg != y.isNeg) {
    y.isNeg = !y.isNeg;
    Ma = biAdd(x, y);
    y.isNeg = !y.isNeg;
  } else {
    Ma = new BigInt();
    var n, c;
    c = 0;
    for (var i = 0; i < x.digits.length; ++i) {
      n = x.digits[i] - y.digits[i] + c;
      Ma.digits[i] = n & 0xffff;
      if (Ma.digits[i] < 0) Ma.digits[i] += biRadix;
      c = 0 - Number(n < 0);
    }
    if (c == -1) {
      c = 0;
      for (var i = 0; i < x.digits.length; ++i) {
        n = 0 - Ma.digits[i] + c;
        Ma.digits[i] = n & 0xffff;
        if (Ma.digits[i] < 0) Ma.digits[i] += biRadix;
        c = 0 - Number(n < 0);
      }
      Ma.isNeg = !x.isNeg;
    } else {
      Ma.isNeg = x.isNeg;
    }
  }
  return Ma;
}

function biHighIndex(x) {
  var Na = x.digits.length - 1;
  while (Na > 0 && x.digits[Na] == 0) --Na;
  return Na;
}

function biNumBits(x) {
  var n = biHighIndex(x);
  var d = x.digits[n];
  var m = (n + 1) * bitsPerDigit;
  var Oa;
  for (Oa = m; Oa > m - bitsPerDigit; --Oa) {
    if ((d & 0x8000) != 0) break;
    d <<= 1;
  }
  return Oa;
}

function biMultiply(x, y) {
  var Pa = new BigInt();
  var c;
  var n = biHighIndex(x);
  var t = biHighIndex(y);
  var u, uv, k;
  for (var i = 0; i <= t; ++i) {
    c = 0;
    k = i;
    for (j = 0; j <= n; ++j, ++k) {
      uv = Pa.digits[k] + x.digits[j] * y.digits[i] + c;
      Pa.digits[k] = uv & maxDigitVal;
      c = uv >>> biRadixBits;
    }
    Pa.digits[i + n + 1] = c;
  }
  Pa.isNeg = x.isNeg != y.isNeg;
  return Pa;
}

function biMultiplyDigit(x, y) {
  var n, c, uv;
  result = new BigInt();
  n = biHighIndex(x);
  c = 0;
  for (var j = 0; j <= n; ++j) {
    uv = result.digits[j] + x.digits[j] * y + c;
    result.digits[j] = uv & maxDigitVal;
    c = uv >>> biRadixBits;
  }
  result.digits[1 + n] = c;
  return result;
}

function arrayCopy(Qa, Ra, Sa, Ta, n) {
  var m = Math.min(Ra + n, Qa.length);
  for (var i = Ra, j = Ta; i < m; ++i, ++j) {
    Sa[j] = Qa[i];
  }
}

var highBitMasks = new Array(
  0x0000,
  0x8000,
  0xc000,
  0xe000,
  0xf000,
  0xf800,
  0xfc00,
  0xfe00,
  0xff00,
  0xff80,
  0xffc0,
  0xffe0,
  0xfff0,
  0xfff8,
  0xfffc,
  0xfffe,
  0xffff
);

function biShiftLeft(x, n) {
  var Ua = Math.floor(n / bitsPerDigit);
  var Va = new BigInt();
  arrayCopy(x.digits, 0, Va.digits, Ua, Va.digits.length - Ua);
  var Wa = n % bitsPerDigit;
  var Xa = bitsPerDigit - Wa;
  for (var i = Va.digits.length - 1, i1 = i - 1; i > 0; --i, --i1) {
    Va.digits[i] =
      ((Va.digits[i] << Wa) & maxDigitVal) |
      ((Va.digits[i1] & highBitMasks[Wa]) >>> Xa);
  }
  Va.digits[0] = (Va.digits[i] << Wa) & maxDigitVal;
  Va.isNeg = x.isNeg;
  return Va;
}

var lowBitMasks = new Array(
  0x0000,
  0x0001,
  0x0003,
  0x0007,
  0x000f,
  0x001f,
  0x003f,
  0x007f,
  0x00ff,
  0x01ff,
  0x03ff,
  0x07ff,
  0x0fff,
  0x1fff,
  0x3fff,
  0x7fff,
  0xffff
);

function biShiftRight(x, n) {
  var Ya = Math.floor(n / bitsPerDigit);
  var Za = new BigInt();
  arrayCopy(x.digits, Ya, Za.digits, 0, x.digits.length - Ya);
  var $a = n % bitsPerDigit;
  var ab = bitsPerDigit - $a;
  for (var i = 0, i1 = i + 1; i < Za.digits.length - 1; ++i, ++i1) {
    Za.digits[i] =
      (Za.digits[i] >>> $a) | ((Za.digits[i1] & lowBitMasks[$a]) << ab);
  }
  Za.digits[Za.digits.length - 1] >>>= $a;
  Za.isNeg = x.isNeg;
  return Za;
}

function biMultiplyByRadixPower(x, n) {
  var bb = new BigInt();
  arrayCopy(x.digits, 0, bb.digits, n, bb.digits.length - n);
  return bb;
}

function biDivideByRadixPower(x, n) {
  var cb = new BigInt();
  arrayCopy(x.digits, n, cb.digits, 0, cb.digits.length - n);
  return cb;
}

function biModuloByRadixPower(x, n) {
  var db = new BigInt();
  arrayCopy(x.digits, 0, db.digits, 0, n);
  return db;
}

function biCompare(x, y) {
  if (x.isNeg != y.isNeg) {
    return 1 - 2 * Number(x.isNeg);
  }
  for (var i = x.digits.length - 1; i >= 0; --i) {
    if (x.digits[i] != y.digits[i]) {
      if (x.isNeg) {
        return 1 - 2 * Number(x.digits[i] > y.digits[i]);
      } else {
        return 1 - 2 * Number(x.digits[i] < y.digits[i]);
      }
    }
  }
  return 0;
}

function biDivideModulo(x, y) {
  var nb = biNumBits(x);
  var tb = biNumBits(y);
  var eb = y.isNeg;
  var q, r;
  if (nb < tb) {
    if (x.isNeg) {
      q = biCopy(bigOne);
      q.isNeg = !y.isNeg;
      x.isNeg = false;
      y.isNeg = false;
      r = biSubtract(y, x);
      x.isNeg = true;
      y.isNeg = eb;
    } else {
      q = new BigInt();
      r = biCopy(x);
    }
    return new Array(q, r);
  }
  q = new BigInt();
  r = x;
  var t = Math.ceil(tb / bitsPerDigit) - 1;
  var fb = 0;
  while (y.digits[t] < biHalfRadix) {
    y = biShiftLeft(y, 1);
    ++fb;
    ++tb;
    t = Math.ceil(tb / bitsPerDigit) - 1;
  }
  r = biShiftLeft(r, fb);
  nb += fb;
  var n = Math.ceil(nb / bitsPerDigit) - 1;
  var b = biMultiplyByRadixPower(y, n - t);
  while (biCompare(r, b) != -1) {
    ++q.digits[n - t];
    r = biSubtract(r, b);
  }
  for (var i = n; i > t; --i) {
    var ri = i >= r.digits.length ? 0 : r.digits[i];
    var gb = i - 1 >= r.digits.length ? 0 : r.digits[i - 1];
    var hb = i - 2 >= r.digits.length ? 0 : r.digits[i - 2];
    var yt = t >= y.digits.length ? 0 : y.digits[t];
    var ib = t - 1 >= y.digits.length ? 0 : y.digits[t - 1];
    if (ri == yt) {
      q.digits[i - t - 1] = maxDigitVal;
    } else {
      q.digits[i - t - 1] = Math.floor((ri * biRadix + gb) / yt);
    }
    var c1 = q.digits[i - t - 1] * (yt * biRadix + ib);
    var c2 = ri * biRadixSquared + (gb * biRadix + hb);
    while (c1 > c2) {
      --q.digits[i - t - 1];
      c1 = q.digits[i - t - 1] * ((yt * biRadix) | ib);
      c2 = ri * biRadix * biRadix + (gb * biRadix + hb);
    }
    b = biMultiplyByRadixPower(y, i - t - 1);
    r = biSubtract(r, biMultiplyDigit(b, q.digits[i - t - 1]));
    if (r.isNeg) {
      r = biAdd(r, b);
      --q.digits[i - t - 1];
    }
  }
  r = biShiftRight(r, fb);
  q.isNeg = x.isNeg != eb;
  if (x.isNeg) {
    if (eb) {
      q = biAdd(q, bigOne);
    } else {
      q = biSubtract(q, bigOne);
    }
    y = biShiftRight(y, fb);
    r = biSubtract(y, r);
  }
  if (r.digits[0] == 0 && biHighIndex(r) == 0) r.isNeg = false;
  return new Array(q, r);
}

function biDivide(x, y) {
  return biDivideModulo(x, y)[0];
}

function biModulo(x, y) {
  return biDivideModulo(x, y)[1];
}

function biMultiplyMod(x, y, m) {
  return biModulo(biMultiply(x, y), m);
}

function biPow(x, y) {
  var jb = bigOne;
  var a = x;
  while (true) {
    if ((y & 1) != 0) jb = biMultiply(jb, a);
    y >>= 1;
    if (y == 0) break;
    a = biMultiply(a, a);
  }
  return jb;
}

function biPowMod(x, y, m) {
  var kb = bigOne;
  var a = x;
  var k = y;
  while (true) {
    if ((k.digits[0] & 1) != 0) kb = biMultiplyMod(kb, a, m);
    k = biShiftRight(k, 1);
    if (k.digits[0] == 0 && biHighIndex(k) == 0) break;
    a = biMultiplyMod(a, a, m);
  }
  return kb;
}
var MAX_HASH_SIZE_IN_BYTES = 20;
var NUM_OF_BITS_PER_BLOCK = 512;
var NUM_OF_BITS_PER_BYTE = 8;
var NUM_OF_BITS_PER_WORD = 32;
var NUM_OF_BITS_FOR_MSG_LENGTH = 64;
var MSG_LENGTH_BYTE_ARRAY_OFFSET = 60;
var NUM_OF_BYTES_PER_BLOCK = 64;
var NUM_OF_BYTES_PER_WORD = 4;
var NUM_OF_WORDS_PER_BLOCK = 16;
var MAX_NUM_OF_PROCESS_STEPS = 80;
var PROCESSING_STEP_19 = 19;
var PROCESSING_STEP_39 = 39;
var PROCESSING_STEP_59 = 59;
var PROCESSING_STEP_79 = 79;
var K1 = 1518500249;
var K2 = 1859775393;
var K3 = -1894007588;
var K4 = -899497514;
var A, B, C, D, E;
var temp;
var W = new Array(MAX_NUM_OF_PROCESS_STEPS);
var M = new Array(NUM_OF_WORDS_PER_BLOCK);
var numOfIntegralBlocksInMsg;
var numOfPaddedMsgBlocks;
var hashByteArray = new Array(MAX_HASH_SIZE_IN_BYTES);
var lastPaddedMsgBlock = new Array(NUM_OF_WORDS_PER_BLOCK);
var secondLastPaddedMsgBlock = new Array(NUM_OF_WORDS_PER_BLOCK);

function doHash(aa, ba) {
  var H0 = 1732584193;
  var H1 = -271733879;
  var H2 = -1732584194;
  var H3 = 271733878;
  var H4 = -1009589776;
  var ca, t, tempWord;
  padInputMessage(aa, ba);
  for (ca = 1; ca <= numOfPaddedMsgBlocks; ca++) {
    if (ca <= numOfIntegralBlocksInMsg) {
      convertByteArrayToBlock(M, aa, ca - 1);
    } else if (ca == numOfPaddedMsgBlocks) {
      arrayCopy(lastPaddedMsgBlock, 0, M, 0, NUM_OF_WORDS_PER_BLOCK);
    } else {
      arrayCopy(secondLastPaddedMsgBlock, 0, M, 0, NUM_OF_WORDS_PER_BLOCK);
    }
    arrayCopy(M, 0, W, 0, NUM_OF_WORDS_PER_BLOCK);
    for (t = NUM_OF_WORDS_PER_BLOCK; t < MAX_NUM_OF_PROCESS_STEPS; t++) {
      tempWord = W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16];
      W[t] = rotateWordLeft(tempWord, 1);
    }
    A = H0;
    B = H1;
    C = H2;
    D = H3;
    E = H4;
    for (t = 0; t <= PROCESSING_STEP_79; t++) {
      if (t >= 0 && t <= PROCESSING_STEP_19) {
        temp = rotateWordLeft(A, 5) + ((B & C) | (~B & D)) + E + W[t] + K1;
      } else if (t > PROCESSING_STEP_19 && t <= PROCESSING_STEP_39) {
        temp = rotateWordLeft(A, 5) + (B ^ C ^ D) + E + W[t] + K2;
      } else if (t > PROCESSING_STEP_39 && t <= PROCESSING_STEP_59) {
        temp =
          rotateWordLeft(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[t] + K3;
      } else {
        temp = rotateWordLeft(A, 5) + (B ^ C ^ D) + E + W[t] + K4;
      }
      E = D;
      D = C;
      C = rotateWordLeft(B, 30);
      B = A;
      A = temp;
    }
    H0 = safe_add(H0, A);
    H1 = safe_add(H1, B);
    H2 = safe_add(H2, C);
    H3 = safe_add(H3, D);
    H4 = safe_add(H4, E);
  }
  convertIntToByteArray(H0, hashByteArray, 0);
  convertIntToByteArray(H1, hashByteArray, 4);
  convertIntToByteArray(H2, hashByteArray, 8);
  convertIntToByteArray(H3, hashByteArray, 12);
  convertIntToByteArray(H4, hashByteArray, 16);
  return hashByteArray;
}

function padInputMessage(da, ea) {
  var fa, remainingBytesInMsg, remainingBitsInMsg;
  var ga;
  var ha = new Array(NUM_OF_BYTES_PER_BLOCK);
  fa = ea * NUM_OF_BITS_PER_BYTE;
  numOfIntegralBlocksInMsg = parseInt(ea / NUM_OF_BYTES_PER_BLOCK);
  ga = numOfIntegralBlocksInMsg * NUM_OF_BYTES_PER_BLOCK;
  remainingBytesInMsg = ea - ga;
  remainingBitsInMsg = remainingBytesInMsg * NUM_OF_BITS_PER_BYTE;
  numOfPaddedMsgBlocks = numOfIntegralBlocksInMsg + 1;
  fillByteArray(ha, 0);
  arrayCopy(da, ga, ha, 0, remainingBytesInMsg);
  ha[remainingBytesInMsg] = parseInt(0x80);
  if (
    remainingBitsInMsg >
    NUM_OF_BITS_PER_BLOCK - NUM_OF_BITS_FOR_MSG_LENGTH - 1
  ) {
    secondLastPaddedMsgBlock = new Array(NUM_OF_WORDS_PER_BLOCK);
    convertByteArrayToBlock(secondLastPaddedMsgBlock, ha, 0);
    fillByteArray(ha, 0);
    convertIntToByteArray(fa, ha, MSG_LENGTH_BYTE_ARRAY_OFFSET);
    convertByteArrayToBlock(lastPaddedMsgBlock, ha, 0);
    numOfPaddedMsgBlocks++;
  } else {
    convertIntToByteArray(fa, ha, MSG_LENGTH_BYTE_ARRAY_OFFSET);
    convertByteArrayToBlock(lastPaddedMsgBlock, ha, 0);
  }
  return;
}

function rotateWordLeft(ia, ja) {
  var ka;
  ka = (ia << ja) | (ia >>> (NUM_OF_BITS_PER_WORD - ja));
  return ka;
}

function convertByteArrayToBlock(la, ma, na) {
  var oa, wordCount, byteCount, wordOffset, tempWord;
  oa = na * NUM_OF_BYTES_PER_BLOCK;
  for (wordCount = 0; wordCount < NUM_OF_WORDS_PER_BLOCK; wordCount++) {
    wordOffset = oa + wordCount * NUM_OF_BYTES_PER_WORD;
    la[wordCount] = convertByteArrayToInt(ma, wordOffset);
  }
  return;
}

function convertByteArrayToInt(pa, qa) {
  var ra, outputWord;
  ra = parseInt(pa[qa] & 0x000000ff);
  outputWord = ra << 24;
  ra = parseInt(pa[qa + 1] & 0x000000ff);
  outputWord = outputWord | (ra << 16);
  ra = parseInt(pa[qa + 2] & 0x000000ff);
  outputWord = outputWord | (ra << 8);
  ra = parseInt(pa[qa + 3] & 0x000000ff);
  outputWord = outputWord | ra;
  return outputWord;
}

function convertIntToByteArray(sa, ta, ua) {
  ta[ua] = ShiftRightFunc(sa, 24) & 0x000000ff;
  ta[ua + 1] = ShiftRightFunc(sa, 16) & 0x000000ff;
  ta[ua + 2] = ShiftRightFunc(sa, 8) & 0x000000ff;
  ta[ua + 3] = sa & 0x000000ff;
  return;
}

function safe_add(x, y) {
  var va = (x & 0xffff) + (y & 0xffff);
  var wa =
    ShiftRightFunc(x, 16) + ShiftRightFunc(y, 16) + ShiftRightFunc(va, 16);
  return (wa << 16) | (va & 0xffff);
}

function ShiftRight(n, noOfBits) {
  return n >> noOfBits;
}
var powerOfTwo = [
  0x00000001,
  0x00000002,
  0x00000004,
  0x00000008,
  0x00000010,
  0x00000020,
  0x00000040,
  0x00000080,
  0x00000100,
  0x00000200,
  0x00000400,
  0x00000800,
  0x00001000,
  0x00002000,
  0x00004000,
  0x00008000,
  0x00010000,
  0x00020000,
  0x00040000,
  0x00080000,
  0x00100000,
  0x00200000,
  0x00400000,
  0x00800000,
  0x01000000,
  0x02000000,
  0x04000000,
  0x08000000,
  0x10000000,
  0x20000000,
  0x40000000,
  0x80000000
];
var _0x9e07 = [];
var bitMaskArray = null;
function ShiftRight2(_0x1c81x3, _0x1c81x4) {
  if (bitMaskArray == null) {
    bitMaskArray = new Array(32);
    for (i = 0; i < 32; i++) {
      if (i > 0) {
        bitMaskArray[i] = bitMaskArray[i - 1] + powerOfTwo[i];
      } else {
        bitMaskArray[i] = powerOfTwo[i];
      }
    }
  }
  if (_0x1c81x3 >= -2147483648 && _0x1c81x3 <= 2147483647) {
    return _0x1c81x3 >> _0x1c81x4;
  } else {
    if (_0x1c81x4 < 32) {
      return (
        ((_0x1c81x3 & ~bitMaskArray[_0x1c81x4 - 1]) / powerOfTwo[_0x1c81x4]) |
        ((_0x1c81x3 & powerOfTwo[31]) == powerOfTwo[31]
          ? ~bitMaskArray[_0x1c81x4 - 1]
          : 0)
      );
    } else {
      return 0;
    }
  }
}
var ShiftRightFunc = -2160220835 >> 16 == 32573 ? ShiftRight : ShiftRight2;
function parseBigInt(aa, r) {
  return new BigInteger(aa, r);
}

function linebrk(s, n) {
  var ca = "";
  var i = 0;
  while (i + n < s.length) {
    ca += s.substring(i, i + n) + "\n";
    i += n;
  }
  return ca + s.substring(i, s.length);
}

function byte2Hex(b) {
  if (b < 0x10) return "0" + b.toString(16);
  else return b.toString(16);
}

function pkcs1pad2(s, n) {
  if (n < s.length + 11) {
    console.log("Message too long for RSA");
    return null;
  }

  var ba = new Array();
  var i = s.length - 1;
  while (i >= 0 && n > 0) ba[--n] = s.charCodeAt(i--);
  ba[--n] = 0;
  var da = new SecureRandom();
  var x = new Array();
  while (n > 2) {
    x[0] = 0;
    while (x[0] == 0) da.nextBytes(x);
    ba[--n] = x[0];
  }
  ba[--n] = 2;
  ba[--n] = 0;
  return new BigInteger(ba);
}

function RSAKey() {
  this.n = null;
  this.e = 0;
  this.d = null;
  this.p = null;
  this.q = null;
  this.dmp1 = null;
  this.dmq1 = null;
  this.coeff = null;
}

function RSASetPublic(N, E) {
  if (N != null && E != null && N.length > 0 && E.length > 0) {
    this.n = parseBigInt(N, 16);
    this.e = parseBigInt(E, 16);
  } else console.log("Invalid RSA public key");
}

function RSADoPublic(x) {
  return x.modPowInt(this.e, this.n);
}

function RSAEncrypt(ea) {
  var m = parseBigInt(ea, 16);
  if (m == null) return null;
  var c = this.doPublic(m);
  if (c == null) return null;
  var h = c.toString(16);
  if ((h.length & 1) == 0) return h;
  else return "0" + h;
}

RSAKey.prototype.doPublic = RSADoPublic;
RSAKey.prototype.setPublic = RSASetPublic;
RSAKey.prototype.encrypt = RSAEncrypt;
var dbits;
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;
function BigInteger(a, b, c) {
  if (a != null)
    if ("number" == typeof a) this.fromNumber(a, b, c);
    else if (b == null && "string" != typeof a) this.fromString(a, 256);
    else this.fromString(a, b);
}

function nbi() {
  return new BigInteger(null);
}

function am1(i, x, w, j, c, n) {
  while (--n >= 0) {
    var v = x * this[i++] + w[j] + c;
    c = Math.floor(v / 0x4000000);
    w[j++] = v & 0x3ffffff;
  }
  return c;
}

function am2(i, x, w, j, c, n) {
  var xl = x & 0x7fff,
    xh = x >> 15;
  while (--n >= 0) {
    var l = this[i] & 0x7fff;
    var h = this[i++] >> 15;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
    w[j++] = l & 0x3fffffff;
  }
  return c;
}

function am3(i, x, w, j, c, n) {
  var xl = x & 0x3fff,
    xh = x >> 14;
  while (--n >= 0) {
    var l = this[i] & 0x3fff;
    var h = this[i++] >> 14;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
    c = (l >> 28) + (m >> 14) + xh * h;
    w[j++] = l & 0xfffffff;
  }
  return c;
}

if (j_lm && navigator.appName == "Microsoft Internet Explorer") {
  BigInteger.prototype.am = am2;
  dbits = 30;
} else if (j_lm && navigator.appName != "Netscape") {
  BigInteger.prototype.am = am1;
  dbits = 26;
} else {
  BigInteger.prototype.am = am3;
  dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

function int2char(n) {
  return BI_RM.charAt(n);
}

function intAt(s, i) {
  var c = BI_RC[s.charCodeAt(i)];
  return c == null ? -1 : c;
}

function bnpCopyTo(r) {
  for (var i = this.t - 1; i >= 0; --i) r[i] = this[i];
  r.t = this.t;
  r.s = this.s;
}

function bnpFromInt(x) {
  this.t = 1;
  this.s = x < 0 ? -1 : 0;
  if (x > 0) this[0] = x;
  else if (x < -1) this[0] = x + DV;
  else this.t = 0;
}

function nbv(i) {
  var r = nbi();
  r.fromInt(i);
  return r;
}

function bnpFromString(s, b) {
  var k;
  if (b == 16) k = 4;
  else if (b == 8) k = 3;
  else if (b == 256) k = 8;
  else if (b == 2) k = 1;
  else if (b == 32) k = 5;
  else if (b == 4) k = 2;
  else {
    this.fromRadix(s, b);
    return;
  }
  this.t = 0;
  this.s = 0;
  var i = s.length,
    mi = false,
    sh = 0;
  while (--i >= 0) {
    var x = k == 8 ? s[i] & 0xff : intAt(s, i);
    if (x < 0) {
      if (s.charAt(i) == "-") mi = true;
      continue;
    }
    mi = false;
    if (sh == 0) this[this.t++] = x;
    else if (sh + k > this.DB) {
      this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
      this[this.t++] = x >> (this.DB - sh);
    } else this[this.t - 1] |= x << sh;
    sh += k;
    if (sh >= this.DB) sh -= this.DB;
  }
  if (k == 8 && (s[0] & 0x80) != 0) {
    this.s = -1;
    if (sh > 0) this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
  }
  this.clamp();
  if (mi) BigInteger.ZERO.subTo(this, this);
}

function bnpClamp() {
  var c = this.s & this.DM;
  while (this.t > 0 && this[this.t - 1] == c) --this.t;
}

function bnToString(b) {
  if (this.s < 0) return "-" + this.negate().toString(b);
  var k;
  if (b == 16) k = 4;
  else if (b == 8) k = 3;
  else if (b == 2) k = 1;
  else if (b == 32) k = 5;
  else if (b == 4) k = 2;
  else return this.toRadix(b);
  var km = (1 << k) - 1,
    d,
    m = false,
    r = "",
    i = this.t;
  var p = this.DB - ((i * this.DB) % k);
  if (i-- > 0) {
    if (p < this.DB && (d = this[i] >> p) > 0) {
      m = true;
      r = int2char(d);
    }
    while (i >= 0) {
      if (p < k) {
        d = (this[i] & ((1 << p) - 1)) << (k - p);
        d |= this[--i] >> (p += this.DB - k);
      } else {
        d = (this[i] >> (p -= k)) & km;
        if (p <= 0) {
          p += this.DB;
          --i;
        }
      }
      if (d > 0) m = true;
      if (m) r += int2char(d);
    }
  }
  return m ? r : "0";
}

function bnNegate() {
  var r = nbi();
  BigInteger.ZERO.subTo(this, r);
  return r;
}

function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}

function bnCompareTo(a) {
  var r = this.s - a.s;
  if (r != 0) return r;
  var i = this.t;
  r = i - a.t;
  if (r != 0) return r;
  while (--i >= 0) if ((r = this[i] - a[i]) != 0) return r;
  return 0;
}

function nbits(x) {
  var r = 1,
    t;
  if ((t = x >>> 16) != 0) {
    x = t;
    r += 16;
  }
  if ((t = x >> 8) != 0) {
    x = t;
    r += 8;
  }
  if ((t = x >> 4) != 0) {
    x = t;
    r += 4;
  }
  if ((t = x >> 2) != 0) {
    x = t;
    r += 2;
  }
  if ((t = x >> 1) != 0) {
    x = t;
    r += 1;
  }
  return r;
}

function bnBitLength() {
  if (this.t <= 0) return 0;
  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
}

function bnpDLShiftTo(n, r) {
  var i;
  for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i];
  for (i = n - 1; i >= 0; --i) r[i] = 0;
  r.t = this.t + n;
  r.s = this.s;
}

function bnpDRShiftTo(n, r) {
  for (var i = n; i < this.t; ++i) r[i - n] = this[i];
  r.t = Math.max(this.t - n, 0);
  r.s = this.s;
}

function bnpLShiftTo(n, r) {
  var bs = n % this.DB;
  var aa = this.DB - bs;
  var bm = (1 << aa) - 1;
  var ds = Math.floor(n / this.DB),
    c = (this.s << bs) & this.DM,
    i;
  for (i = this.t - 1; i >= 0; --i) {
    r[i + ds + 1] = (this[i] >> aa) | c;
    c = (this[i] & bm) << bs;
  }
  for (i = ds - 1; i >= 0; --i) r[i] = 0;
  r[ds] = c;
  r.t = this.t + ds + 1;
  r.s = this.s;
  r.clamp();
}

function bnpRShiftTo(n, r) {
  r.s = this.s;
  var ds = Math.floor(n / this.DB);
  if (ds >= this.t) {
    r.t = 0;
    return;
  }
  var bs = n % this.DB;
  var ba = this.DB - bs;
  var bm = (1 << bs) - 1;
  r[0] = this[ds] >> bs;
  for (var i = ds + 1; i < this.t; ++i) {
    r[i - ds - 1] |= (this[i] & bm) << ba;
    r[i - ds] = this[i] >> bs;
  }
  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << ba;
  r.t = this.t - ds;
  r.clamp();
}

function bnpSubTo(a, r) {
  var i = 0,
    c = 0,
    m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] - a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c -= a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c -= a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c -= a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c < -1) r[i++] = this.DV + c;
  else if (c > 0) r[i++] = c;
  r.t = i;
  r.clamp();
}

function bnpMultiplyTo(a, r) {
  var x = this.abs(),
    y = a.abs();
  var i = x.t;
  r.t = i + y.t;
  while (--i >= 0) r[i] = 0;
  for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
  r.s = 0;
  r.clamp();
  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}

function bnpSquareTo(r) {
  var x = this.abs();
  var i = (r.t = 2 * x.t);
  while (--i >= 0) r[i] = 0;
  for (i = 0; i < x.t - 1; ++i) {
    var c = x.am(i, x[i], r, 2 * i, 0, 1);
    if (
      (r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >=
      x.DV
    ) {
      r[i + x.t] -= x.DV;
      r[i + x.t + 1] = 1;
    }
  }
  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
  r.s = 0;
  r.clamp();
}

function bnpDivRemTo(m, q, r) {
  var pm = m.abs();
  if (pm.t <= 0) return;
  var pt = this.abs();
  if (pt.t < pm.t) {
    if (q != null) q.fromInt(0);
    if (r != null) this.copyTo(r);
    return;
  }
  if (r == null) r = nbi();
  var y = nbi(),
    ts = this.s,
    ms = m.s;
  var ca = this.DB - nbits(pm[pm.t - 1]);
  if (ca > 0) {
    pm.lShiftTo(ca, y);
    pt.lShiftTo(ca, r);
  } else {
    pm.copyTo(y);
    pt.copyTo(r);
  }
  var ys = y.t;
  var y0 = y[ys - 1];
  if (y0 == 0) return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt,
    d2 = (1 << this.F1) / yt,
    e = 1 << this.F2;
  var i = r.t,
    j = i - ys,
    t = q == null ? nbi() : q;
  y.dlShiftTo(j, t);
  if (r.compareTo(t) >= 0) {
    r[r.t++] = 1;
    r.subTo(t, r);
  }
  BigInteger.ONE.dlShiftTo(ys, t);
  t.subTo(y, y);
  while (y.t < ys) y[y.t++] = 0;
  while (--j >= 0) {
    var qd =
      r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
      y.dlShiftTo(j, t);
      r.subTo(t, r);
      while (r[i] < --qd) r.subTo(t, r);
    }
  }
  if (q != null) {
    r.drShiftTo(ys, q);
    if (ts != ms) BigInteger.ZERO.subTo(q, q);
  }
  r.t = ys;
  r.clamp();
  if (ca > 0) r.rShiftTo(ca, r);
  if (ts < 0) BigInteger.ZERO.subTo(r, r);
}

function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a, null, r);
  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
  return r;
}

function Classic(m) {
  this.m = m;
}

function cConvert(x) {
  if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
  else return x;
}

function cRevert(x) {
  return x;
}

function cReduce(x) {
  x.divRemTo(this.m, null, x);
}

function cMulTo(x, y, r) {
  x.multiplyTo(y, r);
  this.reduce(r);
}

function cSqrTo(x, r) {
  x.squareTo(r);
  this.reduce(r);
}

Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;

function bnpInvDigit() {
  if (this.t < 1) return 0;
  var x = this[0];
  if ((x & 1) == 0) return 0;
  var y = x & 3;
  y = (y * (2 - (x & 0xf) * y)) & 0xf;
  y = (y * (2 - (x & 0xff) * y)) & 0xff;
  y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff;
  y = (y * (2 - ((x * y) % this.DV))) % this.DV;
  return y > 0 ? this.DV - y : -y;
}

function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp & 0x7fff;
  this.mph = this.mp >> 15;
  this.um = (1 << (m.DB - 15)) - 1;
  this.mt2 = 2 * m.t;
}

function montConvert(x) {
  var r = nbi();
  x.abs().dlShiftTo(this.m.t, r);
  r.divRemTo(this.m, null, r);
  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
  return r;
}

function montRevert(x) {
  var r = nbi();
  x.copyTo(r);
  this.reduce(r);
  return r;
}

function montReduce(x) {
  while (x.t <= this.mt2) x[x.t++] = 0;
  for (var i = 0; i < this.m.t; ++i) {
    var j = x[i] & 0x7fff;
    var u0 =
      (j * this.mpl +
        (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) &
      x.DM;
    j = i + this.m.t;
    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
    while (x[j] >= x.DV) {
      x[j] -= x.DV;
      x[++j]++;
    }
  }
  x.clamp();
  x.drShiftTo(this.m.t, x);
  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

function montSqrTo(x, r) {
  x.squareTo(r);
  this.reduce(r);
}

function montMulTo(x, y, r) {
  x.multiplyTo(y, r);
  this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

function bnpIsEven() {
  return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}

function bnpExp(e, z) {
  if (e > 0xffffffff || e < 1) return BigInteger.ONE;
  var r = nbi(),
    r2 = nbi(),
    g = z.convert(this),
    i = nbits(e) - 1;
  g.copyTo(r);
  while (--i >= 0) {
    z.sqrTo(r, r2);
    if ((e & (1 << i)) > 0) z.mulTo(r2, g, r);
    else {
      var t = r;
      r = r2;
      r2 = t;
    }
  }
  return z.revert(r);
}

function bnModPowInt(e, m) {
  var z;
  if (e < 256 || m.isEven()) z = new Classic(m);
  else z = new Montgomery(m);
  return this.exp(e, z);
}

BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.isEven = bnpIsEven;
BigInteger.prototype.exp = bnpExp;
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.modPowInt = bnModPowInt;
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);
function bnClone() {
  var r = nbi();
  this.copyTo(r);
  return r;
}

function bnIntValue() {
  if (this.s < 0) {
    if (this.t == 1) return this[0] - this.DV;
    else if (this.t == 0) return -1;
  } else if (this.t == 1) return this[0];
  else if (this.t == 0) return 0;
  return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
}

function bnByteValue() {
  return this.t == 0 ? this.s : (this[0] << 24) >> 24;
}

function bnShortValue() {
  return this.t == 0 ? this.s : (this[0] << 16) >> 16;
}

function bnpChunkSize(r) {
  return Math.floor((Math.LN2 * this.DB) / Math.log(r));
}

function bnSigNum() {
  if (this.s < 0) return -1;
  else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
  else return 1;
}

function bnpToRadix(b) {
  if (b == null) b = 10;
  if (this.signum() == 0 || b < 2 || b > 36) return "0";
  var cs = this.chunkSize(b);
  var a = Math.pow(b, cs);
  var d = nbv(a),
    y = nbi(),
    z = nbi(),
    r = "";
  this.divRemTo(d, y, z);
  while (y.signum() > 0) {
    r = (a + z.intValue()).toString(b).substr(1) + r;
    y.divRemTo(d, y, z);
  }
  return z.intValue().toString(b) + r;
}

function bnpFromRadix(s, b) {
  this.fromInt(0);
  if (b == null) b = 10;
  var cs = this.chunkSize(b);
  var d = Math.pow(b, cs),
    mi = false,
    j = 0,
    w = 0;
  for (var i = 0; i < s.length; ++i) {
    var x = intAt(s, i);
    if (x < 0) {
      if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
      continue;
    }
    w = b * w + x;
    if (++j >= cs) {
      this.dMultiply(d);
      this.dAddOffset(w, 0);
      j = 0;
      w = 0;
    }
  }
  if (j > 0) {
    this.dMultiply(Math.pow(b, j));
    this.dAddOffset(w, 0);
  }
  if (mi) BigInteger.ZERO.subTo(this, this);
}

function bnpFromNumber(a, b, c) {
  if ("number" == typeof b) {
    if (a < 2) this.fromInt(1);
    else {
      this.fromNumber(a, c);
      if (!this.testBit(a - 1))
        this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
      if (this.isEven()) this.dAddOffset(1, 0);
      while (!this.isProbablePrime(b)) {
        this.dAddOffset(2, 0);
        if (this.bitLength() > a)
          this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
      }
    }
  } else {
    var x = new Array(),
      t = a & 7;
    x.length = (a >> 3) + 1;
    b.nextBytes(x);
    if (t > 0) x[0] &= (1 << t) - 1;
    else x[0] = 0;
    this.fromString(x, 256);
  }
}

function bnToByteArray() {
  var i = this.t,
    r = new Array();
  r[0] = this.s;
  var p = this.DB - ((i * this.DB) % 8),
    d,
    k = 0;
  if (i-- > 0) {
    if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p)
      r[k++] = d | (this.s << (this.DB - p));
    while (i >= 0) {
      if (p < 8) {
        d = (this[i] & ((1 << p) - 1)) << (8 - p);
        d |= this[--i] >> (p += this.DB - 8);
      } else {
        d = (this[i] >> (p -= 8)) & 0xff;
        if (p <= 0) {
          p += this.DB;
          --i;
        }
      }
      if ((d & 0x80) != 0) d |= -256;
      if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
      if (k > 0 || d != this.s) r[k++] = d;
    }
  }
  return r;
}

function bnEquals(a) {
  return this.compareTo(a) == 0;
}

function bnMin(a) {
  return this.compareTo(a) < 0 ? this : a;
}

function bnMax(a) {
  return this.compareTo(a) > 0 ? this : a;
}

function bnpBitwiseTo(a, op, r) {
  var i,
    f,
    m = Math.min(a.t, this.t);
  for (i = 0; i < m; ++i) r[i] = op(this[i], a[i]);
  if (a.t < this.t) {
    f = a.s & this.DM;
    for (i = m; i < this.t; ++i) r[i] = op(this[i], f);
    r.t = this.t;
  } else {
    f = this.s & this.DM;
    for (i = m; i < a.t; ++i) r[i] = op(f, a[i]);
    r.t = a.t;
  }
  r.s = op(this.s, a.s);
  r.clamp();
}

function op_and(x, y) {
  return x & y;
}

function bnAnd(a) {
  var r = nbi();
  this.bitwiseTo(a, op_and, r);
  return r;
}

function op_or(x, y) {
  return x | y;
}

function bnOr(a) {
  var r = nbi();
  this.bitwiseTo(a, op_or, r);
  return r;
}

function op_xor(x, y) {
  return x ^ y;
}

function bnXor(a) {
  var r = nbi();
  this.bitwiseTo(a, op_xor, r);
  return r;
}

function op_andnot(x, y) {
  return x & ~y;
}

function bnAndNot(a) {
  var r = nbi();
  this.bitwiseTo(a, op_andnot, r);
  return r;
}

function bnNot() {
  var r = nbi();
  for (var i = 0; i < this.t; ++i) r[i] = this.DM & ~this[i];
  r.t = this.t;
  r.s = ~this.s;
  return r;
}

function bnShiftLeft(n) {
  var r = nbi();
  if (n < 0) this.rShiftTo(-n, r);
  else this.lShiftTo(n, r);
  return r;
}

function bnShiftRight(n) {
  var r = nbi();
  if (n < 0) this.lShiftTo(-n, r);
  else this.rShiftTo(n, r);
  return r;
}

function lbit(x) {
  if (x == 0) return -1;
  var r = 0;
  if ((x & 0xffff) == 0) {
    x >>= 16;
    r += 16;
  }
  if ((x & 0xff) == 0) {
    x >>= 8;
    r += 8;
  }
  if ((x & 0xf) == 0) {
    x >>= 4;
    r += 4;
  }
  if ((x & 3) == 0) {
    x >>= 2;
    r += 2;
  }
  if ((x & 1) == 0) ++r;
  return r;
}

function bnGetLowestSetBit() {
  for (var i = 0; i < this.t; ++i)
    if (this[i] != 0) return i * this.DB + lbit(this[i]);
  if (this.s < 0) return this.t * this.DB;
  return -1;
}

function cbit(x) {
  var r = 0;
  while (x != 0) {
    x &= x - 1;
    ++r;
  }
  return r;
}

function bnBitCount() {
  var r = 0,
    x = this.s & this.DM;
  for (var i = 0; i < this.t; ++i) r += cbit(this[i] ^ x);
  return r;
}

function bnTestBit(n) {
  var j = Math.floor(n / this.DB);
  if (j >= this.t) return this.s != 0;
  return (this[j] & (1 << n % this.DB)) != 0;
}

function bnpChangeBit(n, op) {
  var r = BigInteger.ONE.shiftLeft(n);
  this.bitwiseTo(r, op, r);
  return r;
}

function bnSetBit(n) {
  return this.changeBit(n, op_or);
}

function bnClearBit(n) {
  return this.changeBit(n, op_andnot);
}

function bnFlipBit(n) {
  return this.changeBit(n, op_xor);
}

function bnpAddTo(a, r) {
  var i = 0,
    c = 0,
    m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] + a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c += a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c += a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c > 0) r[i++] = c;
  else if (c < -1) r[i++] = this.DV + c;
  r.t = i;
  r.clamp();
}

function bnAdd(a) {
  var r = nbi();
  this.addTo(a, r);
  return r;
}

function bnSubtract(a) {
  var r = nbi();
  this.subTo(a, r);
  return r;
}

function bnMultiply(a) {
  var r = nbi();
  this.multiplyTo(a, r);
  return r;
}

function bnDivide(a) {
  var r = nbi();
  this.divRemTo(a, r, null);
  return r;
}

function bnRemainder(a) {
  var r = nbi();
  this.divRemTo(a, null, r);
  return r;
}

function bnDivideAndRemainder(a) {
  var q = nbi(),
    r = nbi();
  this.divRemTo(a, q, r);
  return new Array(q, r);
}

function bnpDMultiply(n) {
  this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
  ++this.t;
  this.clamp();
}

function bnpDAddOffset(n, w) {
  while (this.t <= w) this[this.t++] = 0;
  this[w] += n;
  while (this[w] >= this.DV) {
    this[w] -= this.DV;
    if (++w >= this.t) this[this.t++] = 0;
    ++this[w];
  }
}

function NullExp() {}

function nNop(x) {
  return x;
}

function nMulTo(x, y, r) {
  x.multiplyTo(y, r);
}

function nSqrTo(x, r) {
  x.squareTo(r);
}

NullExp.prototype.convert = nNop;
NullExp.prototype.revert = nNop;
NullExp.prototype.mulTo = nMulTo;
NullExp.prototype.sqrTo = nSqrTo;

function bnPow(e) {
  return this.exp(e, new NullExp());
}

function bnpMultiplyLowerTo(a, n, r) {
  var i = Math.min(this.t + a.t, n);
  r.s = 0;
  r.t = i;
  while (i > 0) r[--i] = 0;
  var j;
  for (j = r.t - this.t; i < j; ++i)
    r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
  for (j = Math.min(a.t, n); i < j; ++i) this.am(0, a[i], r, i, 0, n - i);
  r.clamp();
}

function bnpMultiplyUpperTo(a, n, r) {
  --n;
  var i = (r.t = this.t + a.t - n);
  r.s = 0;
  while (--i >= 0) r[i] = 0;
  for (i = Math.max(n - this.t, 0); i < a.t; ++i)
    r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
  r.clamp();
  r.drShiftTo(1, r);
}

function Barrett(m) {
  this.r2 = nbi();
  this.q3 = nbi();
  BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
  this.mu = this.r2.divide(m);
  this.m = m;
}

function barrettConvert(x) {
  if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
  else if (x.compareTo(this.m) < 0) return x;
  else {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
  }
}

function barrettRevert(x) {
  return x;
}

function barrettReduce(x) {
  x.drShiftTo(this.m.t - 1, this.r2);
  if (x.t > this.m.t + 1) {
    x.t = this.m.t + 1;
    x.clamp();
  }
  this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
  this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
  while (x.compareTo(this.r2) < 0) x.dAddOffset(1, this.m.t + 1);
  x.subTo(this.r2, x);
  while (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

function barrettSqrTo(x, r) {
  x.squareTo(r);
  this.reduce(r);
}

function barrettMulTo(x, y, r) {
  x.multiplyTo(y, r);
  this.reduce(r);
}

Barrett.prototype.convert = barrettConvert;
Barrett.prototype.revert = barrettRevert;
Barrett.prototype.reduce = barrettReduce;
Barrett.prototype.mulTo = barrettMulTo;
Barrett.prototype.sqrTo = barrettSqrTo;

function bnModPow(e, m) {
  var i = e.bitLength(),
    k,
    r = nbv(1),
    z;
  if (i <= 0) return r;
  else if (i < 18) k = 1;
  else if (i < 48) k = 3;
  else if (i < 144) k = 4;
  else if (i < 768) k = 5;
  else k = 6;
  if (i < 8) z = new Classic(m);
  else if (m.isEven()) z = new Barrett(m);
  else z = new Montgomery(m);
  var g = new Array(),
    n = 3,
    k1 = k - 1,
    km = (1 << k) - 1;
  g[1] = z.convert(this);
  if (k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1], g2);
    while (n <= km) {
      g[n] = nbi();
      z.mulTo(g2, g[n - 2], g[n]);
      n += 2;
    }
  }
  var j = e.t - 1,
    w,
    is1 = true,
    r2 = nbi(),
    t;
  i = nbits(e[j]) - 1;
  while (j >= 0) {
    if (i >= k1) w = (e[j] >> (i - k1)) & km;
    else {
      w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i);
      if (j > 0) w |= e[j - 1] >> (this.DB + i - k1);
    }
    n = k;
    while ((w & 1) == 0) {
      w >>= 1;
      --n;
    }
    if ((i -= n) < 0) {
      i += this.DB;
      --j;
    }
    if (is1) {
      g[w].copyTo(r);
      is1 = false;
    } else {
      while (n > 1) {
        z.sqrTo(r, r2);
        z.sqrTo(r2, r);
        n -= 2;
      }
      if (n > 0) z.sqrTo(r, r2);
      else {
        t = r;
        r = r2;
        r2 = t;
      }
      z.mulTo(r2, g[w], r);
    }
    while (j >= 0 && (e[j] & (1 << i)) == 0) {
      z.sqrTo(r, r2);
      t = r;
      r = r2;
      r2 = t;
      if (--i < 0) {
        i = this.DB - 1;
        --j;
      }
    }
  }
  return z.revert(r);
}

function bnGCD(a) {
  var x = this.s < 0 ? this.negate() : this.clone();
  var y = a.s < 0 ? a.negate() : a.clone();
  if (x.compareTo(y) < 0) {
    var t = x;
    x = y;
    y = t;
  }
  var i = x.getLowestSetBit(),
    g = y.getLowestSetBit();
  if (g < 0) return x;
  if (i < g) g = i;
  if (g > 0) {
    x.rShiftTo(g, x);
    y.rShiftTo(g, y);
  }
  while (x.signum() > 0) {
    if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
    if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
    if (x.compareTo(y) >= 0) {
      x.subTo(y, x);
      x.rShiftTo(1, x);
    } else {
      y.subTo(x, y);
      y.rShiftTo(1, y);
    }
  }
  if (g > 0) y.lShiftTo(g, y);
  return y;
}

function bnpModInt(n) {
  if (n <= 0) return 0;
  var d = this.DV % n,
    r = this.s < 0 ? n - 1 : 0;
  if (this.t > 0)
    if (d == 0) r = this[0] % n;
    else for (var i = this.t - 1; i >= 0; --i) r = (d * r + this[i]) % n;
  return r;
}

function bnModInverse(m) {
  var ac = m.isEven();
  if ((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;
  var u = m.clone(),
    v = this.clone();
  var a = nbv(1),
    b = nbv(0),
    c = nbv(0),
    d = nbv(1);
  while (u.signum() != 0) {
    while (u.isEven()) {
      u.rShiftTo(1, u);
      if (ac) {
        if (!a.isEven() || !b.isEven()) {
          a.addTo(this, a);
          b.subTo(m, b);
        }
        a.rShiftTo(1, a);
      } else if (!b.isEven()) b.subTo(m, b);
      b.rShiftTo(1, b);
    }
    while (v.isEven()) {
      v.rShiftTo(1, v);
      if (ac) {
        if (!c.isEven() || !d.isEven()) {
          c.addTo(this, c);
          d.subTo(m, d);
        }
        c.rShiftTo(1, c);
      } else if (!d.isEven()) d.subTo(m, d);
      d.rShiftTo(1, d);
    }
    if (u.compareTo(v) >= 0) {
      u.subTo(v, u);
      if (ac) a.subTo(c, a);
      b.subTo(d, b);
    } else {
      v.subTo(u, v);
      if (ac) c.subTo(a, c);
      d.subTo(b, d);
    }
  }
  if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
  if (d.compareTo(m) >= 0) return d.subtract(m);
  if (d.signum() < 0) d.addTo(m, d);
  else return d;
  if (d.signum() < 0) return d.add(m);
  else return d;
}

var lowprimes = [
  2,
  3,
  5,
  7,
  11,
  13,
  17,
  19,
  23,
  29,
  31,
  37,
  41,
  43,
  47,
  53,
  59,
  61,
  67,
  71,
  73,
  79,
  83,
  89,
  97,
  101,
  103,
  107,
  109,
  113,
  127,
  131,
  137,
  139,
  149,
  151,
  157,
  163,
  167,
  173,
  179,
  181,
  191,
  193,
  197,
  199,
  211,
  223,
  227,
  229,
  233,
  239,
  241,
  251,
  257,
  263,
  269,
  271,
  277,
  281,
  283,
  293,
  307,
  311,
  313,
  317,
  331,
  337,
  347,
  349,
  353,
  359,
  367,
  373,
  379,
  383,
  389,
  397,
  401,
  409,
  419,
  421,
  431,
  433,
  439,
  443,
  449,
  457,
  461,
  463,
  467,
  479,
  487,
  491,
  499,
  503,
  509
];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];

function bnIsProbablePrime(t) {
  var i,
    x = this.abs();
  if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
    for (i = 0; i < lowprimes.length; ++i)
      if (x[0] == lowprimes[i]) return true;
    return false;
  }
  if (x.isEven()) return false;
  i = 1;
  while (i < lowprimes.length) {
    var m = lowprimes[i],
      j = i + 1;
    while (j < lowprimes.length && m < lplim) m *= lowprimes[j++];
    m = x.modInt(m);
    while (i < j) if (m % lowprimes[i++] == 0) return false;
  }
  return x.millerRabin(t);
}

function bnpMillerRabin(t) {
  var n1 = this.subtract(BigInteger.ONE);
  var k = n1.getLowestSetBit();
  if (k <= 0) return false;
  var r = n1.shiftRight(k);
  t = (t + 1) >> 1;
  if (t > lowprimes.length) t = lowprimes.length;
  var a = nbi();
  for (var i = 0; i < t; ++i) {
    a.fromInt(lowprimes[i]);
    var y = a.modPow(r, this);
    if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
      var j = 1;
      while (j++ < k && y.compareTo(n1) != 0) {
        y = y.modPowInt(2, this);
        if (y.compareTo(BigInteger.ONE) == 0) return false;
      }
      if (y.compareTo(n1) != 0) return false;
    }
  }
  return true;
}

BigInteger.prototype.chunkSize = bnpChunkSize;
BigInteger.prototype.toRadix = bnpToRadix;
BigInteger.prototype.fromRadix = bnpFromRadix;
BigInteger.prototype.fromNumber = bnpFromNumber;
BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
BigInteger.prototype.changeBit = bnpChangeBit;
BigInteger.prototype.addTo = bnpAddTo;
BigInteger.prototype.dMultiply = bnpDMultiply;
BigInteger.prototype.dAddOffset = bnpDAddOffset;
BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
BigInteger.prototype.modInt = bnpModInt;
BigInteger.prototype.millerRabin = bnpMillerRabin;
BigInteger.prototype.clone = bnClone;
BigInteger.prototype.intValue = bnIntValue;
BigInteger.prototype.byteValue = bnByteValue;
BigInteger.prototype.shortValue = bnShortValue;
BigInteger.prototype.signum = bnSigNum;
BigInteger.prototype.toByteArray = bnToByteArray;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.min = bnMin;
BigInteger.prototype.max = bnMax;
BigInteger.prototype.and = bnAnd;
BigInteger.prototype.or = bnOr;
BigInteger.prototype.xor = bnXor;
BigInteger.prototype.andNot = bnAndNot;
BigInteger.prototype.not = bnNot;
BigInteger.prototype.shiftLeft = bnShiftLeft;
BigInteger.prototype.shiftRight = bnShiftRight;
BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
BigInteger.prototype.bitCount = bnBitCount;
BigInteger.prototype.testBit = bnTestBit;
BigInteger.prototype.setBit = bnSetBit;
BigInteger.prototype.clearBit = bnClearBit;
BigInteger.prototype.flipBit = bnFlipBit;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.remainder = bnRemainder;
BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
BigInteger.prototype.modPow = bnModPow;
BigInteger.prototype.modInverse = bnModInverse;
BigInteger.prototype.pow = bnPow;
BigInteger.prototype.gcd = bnGCD;
BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

export function doE2E(frmPwd, frmRand, frmPStr, frmCStr, isEncrypted) {
  var strO = frmPwd.value;
  var strN = "";

  frmPStr.value = "";
  frmCStr.value = "";

  if (!isEncrypted) {
    isEncrypted = true;
    var RN_String = frmRand.value;
    var PINString = frmPwd.value;
    var P_String = "";
    var C_String = "";

    for (var i = 0; i < strO.length; i++) {
      strN += "*";
    }
    strO = "";
    frmPwd.value = strN;
    var blnJVM_OK = false;

    var errorNum = createPINBlock(PINString, RN_String);

    if (errorNum == 0) {
      C_String = getEncryptedUserLoginMsg();
      P_String = getEncodingParameter();
    } else {
      console.log("Encryption failed with errorNum:" + errorNum);
    }
    blnJVM_OK = C_String != "" && P_String != "";
    if (!blnJVM_OK) {
      console.log("password encryption failed");
      frmPwd.value = "";
      isEncrypted = false;
      return false;
    }

    frmPStr.value = P_String;
    frmCStr.value = C_String;
  }

  return true;
};